<template>
  <div :id="id" class="element-bg" :class="{ 'element-bg-edit': !esHome }">
    <!--menu de elemento -->

    <div class="btns-menu-type">
      <b-badge
        :class="{ ocultarClass: esHome }"
        href="#"
        variant="danger"
        class="align-self-start deleteElement"
        v-on:click="modalDeleteElement = true"
      >
        <font-awesome-icon icon="times" />
      </b-badge>
      <!--Boton de Insertar Elemento-->
      <b-dropdown
        :no-caret="true"
        :id="'insertarE-' + id"
        size="sm"
        variant="info"
        :class="{ ocultarClass: esHome }"
        toggle-class="text-decoration-none"
      >
        <template v-slot:button-content>
          <font-awesome-icon icon="plus-square" />
        </template>
        <b-dropdown-item v-on:click="agregarElemento('Imagen'), (showDelete = true)">
          <font-awesome-icon icon="image" />Insertar Imagen
        </b-dropdown-item>
        <b-dropdown-item v-on:click="agregarElemento('Texto'), (showDelete = true)">
          <font-awesome-icon icon="file-alt" />Insertar Texto
        </b-dropdown-item>
        <b-dropdown-item v-on:click="agregarElemento('Audio'), (showDelete = true)">
          <font-awesome-icon icon="volume-up" />Insertar Audio
        </b-dropdown-item>
        <b-dropdown-item v-on:click="agregarElemento('Video'), (showDelete = true)">
          <font-awesome-icon icon="film" />Insertar Video
        </b-dropdown-item>
        <b-dropdown-item v-on:click="agregarElemento('ImgModal'), (showDelete = true)">
          <font-awesome-icon icon="external-link-alt" />Insertar Modal
        </b-dropdown-item>
        <b-dropdown-item v-on:click="agregarElemento('SeriePops'), (showDelete = true)">
          <font-awesome-icon icon="external-link-alt" />Insertar Conjunto de
          Pops
        </b-dropdown-item>
        <b-dropdown-item v-on:click="agregarElemento('Trivia'), (showDelete = true)">
          <font-awesome-icon icon="list" />Trivia
        </b-dropdown-item>
        <b-dropdown-item v-on:click="agregarElemento('Gallery'), (showDelete = true)">
          <font-awesome-icon icon="photo-video" />Galeria
        </b-dropdown-item>
      </b-dropdown>
      <!--<b-button
        size="sm"
        v-show="showDelete"
        @click=";(modalDelete = !modalDelete), (showDelete = false)"
        variant="danger"
        :id="'borrartrivia' + this.id"
        class="del-trivia"
        :class="{ ocultarClass: esHome }"
      >Eliminar Trivia</b-button>-->
      <!--fin menu de elemento-->
    </div>
    <!--Componente a renderizar-->
    <div class="elem-anim" :data-section="idSection" :data-sub="subid" data-anim ref="animation">
      <!--NOTE el mismo data que recibió Elemento se lo pasa al componente a renderizar-->
      <component
        v-bind:is="typeElemento"
        :esHome="esHome"
        :online="online"
        :data="data"
        :idSection="idSection"
        :subid="subid"
        :elementid="elementid"
      ></component>
    </div>

    <!--Modal para confirmar eliminar un elemento
    <b-modal @ok="deleteTrivia" v-model="modalDelete" title="Eliminar Elemento">
      <div class="container">
        <p>¿Eliminar el Elemento? Se borrará todo su contenido permanentemente.</p>
      </div>
    </b-modal>-->
    <div class="col-12">
      <!--NOTE Modal para confirmar eliminar un elemento-->
      <b-modal
        @ok="deleteElement(elementid)"
        id="modal-delete-element"
        title="Eliminar Elemento"
        no-close-on-backdrop
        v-model="modalDeleteElement"
      >
        <div class="container">
          <p>¿Eliminar elemento? Se borrará todo su contenido permanentemente.</p>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
          <b-button size="sm" variant="danger" @click="ok()">Eliminar</b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Texto from '@/components/atomos/Texto.vue'
import Imagen from '@/components/atomos/Imagen.vue'
import Audio from '@/components/atomos/Audio.vue'
import ImgModal from '@/components/ImgModal.vue'
import Video from '@/components/atomos/Video.vue'
import Trivia from '@/components/Trivia.vue'
import SeriePops from '@/components/SeriePops.vue'
import Gallery from '@/components/Gallery.vue'
import EventBus from '@/components/EventBus'
export default {
  name: 'Elemento',
  components: {
    Texto,
    Imagen,
    Audio,
    ImgModal,
    Video,
    Trivia,
    SeriePops,
    Gallery
  },
  props: {
    idSection: String,
    data: Object,
    subid: Number,
    id: String,
    esHome: Boolean,
    online: Boolean,
    elementid: Number
  },
  data() {
    return {
      typeElemento: '',
      bgcolor: '#ffffff',
      opbg: 10,
      modalShow: false,
      modalDelete: false,
      modalDeleteElement: false,
      modalShowBorder: false,
      borderSize: 1,
      borderColor: '#000000',
      borderStyle: 'solid',
      prueba: 'Imagen',
      showDelete: false,
      hayTrivia: false,
      index: 'id2'
    }
  },

  created() {
    this.delIndex = this.elementid
    EventBus.$emit('DELETE_INDEX', this.delIndex)
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    this.links = this.localRoot['componentes']['header']['links']
    this.hayTrivia = this.localRoot['detalles'][0]['hayTrivia']
    //this.hayTrivia = true
    //NOTE con el arreglo data que nos pasó Section, elemento ya sabe que tipo es
    this.typeElemento = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][this.elementid].type
    //console.log(this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid]['elements'][this.elementid].type)
    //Configurar color de fondo de la sección al cargar
    // console.log(this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid])
  },
  mounted() {
    this.bgcolor = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid]['bgcolor']
    let paro_anim = this.$refs.animation
    paro_anim.dataset.anim = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][this.elementid]['animation']
    // console.log(paro_anim.dataset.anim)
    //this.$refs.bgcontainer.parentNode.style.backgroundColor = this.bgcolor
    //let border = this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid]['border']
    //this.$refs.bgcontainer.parentNode.style.border = border
    //para que se muestre el boton de borrar trivia si se recarga la pagina
    if (this.typeElemento === 'Trivia') {
      let btn = document.getElementById('insertarE-' + this.id)
      btn.style.visibility = 'hidden'
      let btn2 = document.getElementById('borrartrivia' + this.id)
      btn2.style.visibility = 'visible'
      btn2.style.display = 'block'
    }
    this.$nextTick(() => {
      // console.log('inside nextTick callback:')
    })
  },

  methods: {
    agregarElemento(elemento) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      //saca el valor de la trivia (boolean) desde json
      this.hayTrivia = this.localRoot['detalles'][0]['hayTrivia']
      if (elemento === 'Trivia') {
        //si ya hay una trivia en la revista
        if (this.hayTrivia) {
          alert('ya hay una trivia en la revista')
          return
        } else {
          //si no hay trivia, se cambia el valor a true y se guarda en el json
          this.hayTrivia = true
          this.localRoot['detalles'][0]['hayTrivia'] = this.hayTrivia
          let parsedRoot = JSON.stringify(this.localRoot)
          window.localStorage.setItem('root', parsedRoot)
          let btn = document.getElementById('insertarE-' + this.id)
          btn.style.visibility = 'hidden'
          /*let btn2 = document.getElementById('borrartrivia' + this.id)
          btn2.style.visibility = 'visible'*/
        }
      }
      if (elemento === 'Gallery') {
        this.localRoot = JSON.parse(localStorage.getItem('root'))
        let extras = this.localRoot['componentes']['secciones'][this.idSection][
          'existeGaleria'
        ]

        if (extras) {
          alert('Solo puede existir una galeria por seccion.')
          return
        } else {
          this.localRoot['componentes']['secciones'][this.idSection][
            'existeGaleria'
          ] = true
          let parsedRoot = JSON.stringify(this.localRoot)
          window.localStorage.setItem('root', parsedRoot)
        }
      }

      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      let newElement = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid].elements[this.elementid]
      newElement.type = elemento
      newElement.id = this.id + '-' + this.elementid
      newElement.bgcolor = '#ffffff'
      newElement.src = [
        {
          name:
            '<p class="ql-align-center">Inserta </p><p class="ql-align-center">un</p><p class="ql-align-center">elemento</p>',
          url:
            'https://firebasestorage.googleapis.com/v0/b/buro-app.appspot.com/o/imagenes%2Fsampleimg.png?alt=media&token=e91303c7-80e1-47cd-942d-3c95ef72ab41'
        }
      ]
      newElement.position = 'center'
      newElement.animation = 'lr'
      newElement.size = '50'
      if (elemento === 'ImgModal') {
        newElement.extras = [
          {
            sizeM: 100,
            bgcolorM: '#c542f5',
            opM: 10,
            padding: {
              pt: 0,
              pr: 0,
              pb: 0,
              pl: 0
            },
            margin: {
              mt: 0,
              mr: 0,
              mb: 0,
              ml: 0
            }
          }
        ]
        //let parsedRoot = JSON.stringify(this.localRoot)
        //window.localStorage.setItem('root', parsedRoot)
      }
      if (elemento === 'Trivia') {
        newElement.gallery_settings = [
          { sizeM: 100, bgcolorM: '#c542f5', opM: 10, stateBtn: false }
        ]
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      /* let btn = document.getElementById('insertarE-' + this.id)
      btn.style.visibility = 'hidden'*/
      this.typeElemento = elemento
    },
    eliminarElemento() {
      let btn = document.getElementById('insertarE-' + this.id)
      this.typeElemento = ''
      btn.style.visibility = 'visible'
    },

    deleteTrivia() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['detalles'][0]['hayTrivia'] = false
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['type'] = 'Texto'
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras = []
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].src[0].name =
        '<p>Inserta un elemento</p>'
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['src'][0].name =
        '<p>Inserta un elemento</p>'
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.typeElemento = 'Texto'
      let btn = document.getElementById('insertarE-' + this.id)
      btn.style.visibility = 'visible'
      let btn2 = document.getElementById('borrartrivia' + this.id)
      btn2.style.visibility = 'hidden'
    },

    deleteElement(index) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.elements = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements']
      this.$delete(this.elements, index)
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'] = this.elements

      if (this.typeElemento === 'Trivia') {
        this.localRoot['detalles'][0]['hayTrivia'] = false
      }
      if (this.typeElemento === 'Gallery') {
        this.elements = this.localRoot['componentes']['secciones'][this.idSection]['existeGaleria'] = false
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.modalDeleteElement = false
      this.$router.go({
        path: '/editar',
        force: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btns-menu-type {
  position: absolute;
  top: 20px;
  left: -40px;
  display: flex;
}

.btn.sm {
  padding: 0 !important;
}

.del-trivia {
  visibility: hidden;
}

.elem-anim {
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
  opacity: 0;
}

.element-bg {
  /* border: 1px black dotted; */
  position: relative;
}
.element-bg-edit {
  border: 1px black dotted;
  position: relative;
}
.deleteElement {
  position: absolute;
  top: -20px;
  left: 20px;
}
</style>
